function init(root) {
  var cards = Array.prototype.slice.call(root.querySelectorAll('.cb-card'));
  var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-cb-grid]'));
  var sections = Array.prototype.slice.call(root.querySelectorAll('.cb-sec'));
  var $ = function (s) { return root.querySelector(s); };
  var els = {
    search: $('[data-cb-search]'), min: $('[data-cb-min]'), max: $('[data-cb-max]'),
    sale: $('[data-cb-sale]'), pop: $('[data-cb-pop]'), sort: $('[data-cb-sort]'), types: $('[data-cb-types]'),
    results: $('[data-cb-results]'), active: $('[data-cb-active]'), empty: $('[data-cb-empty]'),
    badge: $('[data-cb-badge]'), saleCount: $('[data-cb-sale-count]'), popCount: $('[data-cb-pop-count]'),
    typeGroup: $('[data-cb-type-group]')
  };
  var symbol = root.dataset.symbol || '';
  var state = { q: '', types: [], min: '', max: '', sale: false, pop: false, sort: 'featured' };
  var ORDER = ['bundle', 'agent', 'setup', 'coaching', 'audit'];
  function orderOf(k) { var i = ORDER.indexOf(k); return i === -1 ? 99 : i; }

  /* type facet built from the products on the page */
  var typeMap = {};
  cards.forEach(function (c) { typeMap[c.dataset.type] = c.dataset.typeLabel; });
  var typeKeys = Object.keys(typeMap).sort(function (a, b) { return orderOf(a) - orderOf(b); });
  if (typeKeys.length < 2) { els.typeGroup.style.display = 'none'; }
  typeKeys.forEach(function (k) {
    var lab = document.createElement('label');
    lab.className = 'cb-check';
    lab.innerHTML = '<input type="checkbox" value="' + k + '"> ' + typeMap[k] + ' <span class="cb-count"></span>';
    lab.querySelector('input').addEventListener('change', function () {
      state.types = Array.prototype.map.call(els.types.querySelectorAll('input:checked'), function (i) { return i.value; });
      apply();
    });
    els.types.appendChild(lab);
  });

  function priceOf(c) { return parseInt(c.dataset.price, 10) / 100; }
  function matches(c, skip) {
    if (state.q) {
      var hay = c.dataset.search;
      var terms = state.q.toLowerCase().split(/\s+/);
      for (var i = 0; i < terms.length; i++) { if (terms[i] && hay.indexOf(terms[i]) === -1) return false; }
    }
    if (skip !== 'type' && state.types.length && state.types.indexOf(c.dataset.type) === -1) return false;
    var p = priceOf(c);
    if (state.min !== '' && p < Number(state.min)) return false;
    if (state.max !== '' && p > Number(state.max) + 0.99) return false;
    if (skip !== 'sale' && state.sale && c.dataset.sale !== 'true') return false;
    if (skip !== 'pop' && state.pop && c.dataset.popular !== 'true') return false;
    return true;
  }

  function sortTrack(track) {
    var list = Array.prototype.slice.call(track.querySelectorAll('.cb-card'));
    list.sort(function (a, b) {
      if (state.sort === 'price-asc') return priceOf(a) - priceOf(b);
      if (state.sort === 'price-desc') return priceOf(b) - priceOf(a);
      if (state.sort === 'name') return a.dataset.title < b.dataset.title ? -1 : 1;
      return Number(a.dataset.index) - Number(b.dataset.index);
    });
    list.forEach(function (c) { track.appendChild(c); });
    track.scrollLeft = 0;
  }

  function arrows(track) {
    var wrap = track.parentNode;
    var prev = wrap.querySelector('[data-cb-prev]'), next = wrap.querySelector('[data-cb-next]');
    if (!prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.hidden = track.scrollLeft <= 4;
    next.hidden = max <= 4 || track.scrollLeft >= max - 4;
  }

  function apply() {
    var shown = 0;
    cards.forEach(function (c) { var ok = matches(c, ''); c.hidden = !ok; if (ok) shown++; });
    tracks.forEach(sortTrack);
    sections.forEach(function (s) { s.hidden = !s.querySelector('.cb-card:not([hidden])'); });

    var filtering = !!(state.q || state.types.length || state.min !== '' || state.max !== '' || state.sale || state.pop);
    root.classList.toggle('is-filtering', filtering);

    els.results.innerHTML = 'Showing <strong>' + shown + '</strong> of ' + cards.length + ' products';
    els.empty.classList.toggle('is-on', shown === 0);

    Array.prototype.forEach.call(els.types.querySelectorAll('.cb-check'), function (lab) {
      var k = lab.querySelector('input').value;
      var n = cards.filter(function (c) { return c.dataset.type === k && matches(c, 'type'); }).length;
      lab.querySelector('.cb-count').textContent = n;
      lab.classList.toggle('is-zero', n === 0);
    });
    els.saleCount.textContent = cards.filter(function (c) { return c.dataset.sale === 'true' && matches(c, 'sale'); }).length;
    els.popCount.textContent = cards.filter(function (c) { return c.dataset.popular === 'true' && matches(c, 'pop'); }).length;

    renderActive();
    syncUrl();
    setTimeout(function () { tracks.forEach(arrows); }, 30);
  }

  function renderActive() {
    var tags = [];
    if (state.q) tags.push(['q', 'Search: ' + state.q]);
    state.types.forEach(function (t) { tags.push(['type:' + t, typeMap[t]]); });
    if (state.min !== '' || state.max !== '') {
      var lo = state.min !== '' ? symbol + state.min : symbol + '0';
      var hi = state.max !== '' ? symbol + state.max : 'up';
      tags.push(['price', lo + ' to ' + hi]);
    }
    if (state.pop) tags.push(['pop', 'Most popular']);
    if (state.sale) tags.push(['sale', 'Best value bundles']);
    els.active.innerHTML = '';
    tags.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cb-tag'; b.dataset.key = t[0];
      b.textContent = t[1] + '  ×';
      els.active.appendChild(b);
    });
    els.badge.textContent = tags.length;
    els.badge.hidden = tags.length === 0;
    Array.prototype.forEach.call(root.querySelectorAll('.cb-preset'), function (p) {
      p.classList.toggle('is-on', String(state.min) === String(p.dataset.min) && String(state.max) === String(p.dataset.max));
    });
  }

  function syncUrl() {
    try {
      var u = new URL(window.location.href);
      ['q', 'type', 'min', 'max', 'sale', 'pop', 'sort'].forEach(function (k) { u.searchParams.delete(k); });
      if (state.q) u.searchParams.set('q', state.q);
      if (state.types.length) u.searchParams.set('type', state.types.join(','));
      if (state.min !== '') u.searchParams.set('min', state.min);
      if (state.max !== '') u.searchParams.set('max', state.max);
      if (state.sale) u.searchParams.set('sale', '1');
      if (state.pop) u.searchParams.set('pop', '1');
      if (state.sort !== 'featured') u.searchParams.set('sort', state.sort);
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }

  function syncInputs() {
    els.search.value = state.q; els.min.value = state.min; els.max.value = state.max;
    els.sale.checked = state.sale; els.pop.checked = state.pop; els.sort.value = state.sort;
    Array.prototype.forEach.call(els.types.querySelectorAll('input'), function (i) { i.checked = state.types.indexOf(i.value) > -1; });
  }

  function readUrl() {
    try {
      var p = new URL(window.location.href).searchParams;
      state.q = p.get('q') || '';
      state.types = (p.get('type') || '').split(',').filter(function (t) { return typeMap[t]; });
      state.min = p.get('min') || '';
      state.max = p.get('max') || '';
      state.sale = p.get('sale') === '1';
      state.pop = p.get('pop') === '1';
      state.sort = p.get('sort') || 'featured';
    } catch (e) {}
    syncInputs();
  }

  function clearAll() {
    state = { q: '', types: [], min: '', max: '', sale: false, pop: false, sort: state.sort };
    syncInputs();
    apply();
  }

  var t;
  els.search.addEventListener('input', function () {
    clearTimeout(t);
    t = setTimeout(function () { state.q = els.search.value.trim(); apply(); }, 120);
  });
  els.min.addEventListener('input', function () { state.min = els.min.value; apply(); });
  els.max.addEventListener('input', function () { state.max = els.max.value; apply(); });
  els.sale.addEventListener('change', function () { state.sale = els.sale.checked; apply(); });
  els.pop.addEventListener('change', function () { state.pop = els.pop.checked; apply(); });
  els.sort.addEventListener('change', function () { state.sort = els.sort.value; apply(); });
  Array.prototype.forEach.call(root.querySelectorAll('.cb-preset'), function (p) {
    p.addEventListener('click', function () {
      var on = String(state.min) === String(p.dataset.min) && String(state.max) === String(p.dataset.max);
      state.min = on ? '' : p.dataset.min; state.max = on ? '' : p.dataset.max;
      els.min.value = state.min; els.max.value = state.max; apply();
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-clear]'), function (b) { b.addEventListener('click', clearAll); });
  els.active.addEventListener('click', function (e) {
    var b = e.target.closest('.cb-tag'); if (!b) return;
    var k = b.dataset.key;
    if (k === 'q') state.q = '';
    else if (k === 'price') { state.min = ''; state.max = ''; }
    else if (k === 'sale') state.sale = false;
    else if (k === 'pop') state.pop = false;
    else if (k.indexOf('type:') === 0) {
      var tv = k.slice(5);
      state.types = state.types.filter(function (x) { return x !== tv; });
    }
    syncInputs();
    apply();
  });

  /* row arrows */
  tracks.forEach(function (track) {
    var wrap = track.parentNode;
    var prev = wrap.querySelector('[data-cb-prev]'), next = wrap.querySelector('[data-cb-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { arrows(track); }, { passive: true });
  });
  window.addEventListener('resize', function () { tracks.forEach(arrows); });

  /* mobile drawer */
  root.querySelector('[data-cb-open]').addEventListener('click', function () { root.classList.add('is-drawer-open'); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-close]'), function (b) {
    b.addEventListener('click', function () { root.classList.remove('is-drawer-open'); });
  });

  /* buy now: add to cart then straight to checkout, same as the store section */
  Array.prototype.forEach.call(root.querySelectorAll('[data-cb-buy]'), function (btn) {
    btn.addEventListener('click', function () {
      var orig = btn.textContent;
      btn.disabled = true; btn.textContent = 'Redirecting...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.cbBuy), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        window.location.href = '/checkout';
      }).catch(function () {
        btn.textContent = 'Error, try again'; btn.disabled = false;
        setTimeout(function () { btn.textContent = orig; }, 2500);
      });
    });
  });

  readUrl();
  apply();
}
Array.prototype.forEach.call(document.querySelectorAll('.aal-cb'), init);